
import BaseView from "@core/View.js";
import {$util} from "@util/util.js";

export default class GiftWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;
        this._el = null;
    }
    btn_solid(item){      
      if(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ){
        return `<span class="le_tip_btn_solid" style="margin-right:0.05rem;}">已赠完</span>`
      }else if(item._stock >= 1 && item._stock < this._model._parent._count){
        return `<span class="le_tip_btn_solid" style="margin-right:0.05rem;}">还有${item._stock}件</span>`
      }else {
        return ''
      }
    }
    // <div class="disable_img"></div>
    getItems(){
        let html = "";
        this._model._items.forEach((item,idx) => { 
            let _stockNotEnough = false;
            if(item._stock >= 1 && item._stock < this._model._parent._count){
              _stockNotEnough = true;
            }
            html += `<div class="item_content ${this.getInvalidInfo(item).cls}">
            <div class="e_goods_img">
              <img style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" src="${item._img}">
            </div>
            <div class="e_goods_desc" style="position:relative;">
              ${this.btn_solid(item)}
              <h6 class='lenovo-emoji' style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}; ${_stockNotEnough ? 'max-width:1.25rem;':''}">${item._name}</h6>
              <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'};display:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? 'none':'inline-block'}"" class="e_num">&nbsp;x&nbsp;${item._count}</span>
              <span class="fr e_action" style="position:absolute;right:0rem;display:${item._data.optionGiftFlag && !this._model._parent._invalid ? "block":"none"};">重选<i class="iconfont icon-arrow-right le_vertical_align_m"></i></span>
            </div>
        </div>`;
        });
        return html;
    }

    render(){
        let tmpId = this._model.__tempId + "_" + this._model._parent._id + '_' +this._model._parent._itemId;
        let html = "";
        html += `<div class="extra_item gift iftbox ${this.getInvalidInfo().cls}" skuid='${tmpId}'> 
                  <h3 class="e_name">
                    赠品
                  </h3>
                  <div class="extra_item_content">
                    ${this.getItems()}
                </div>
            </div>`;
        $(this._parentEl).append($(html));
        this._el = $("div.gift[skuid='"+tmpId+"']");
        this.regEvent();
    }
    regEvent() {
      let that = this;
      // 点击选择服务叉号, 隐藏弹窗icon-close
      this._el.off("click", "span.e_action").on("click", "span.e_action", function () {
        that._model._parent.getGiftGoods().then(
          x=>{                      
              that._model._parent._giftList._view.render();
              $(".receive_wrapper").show();    
              $util.toggleBodyScroller(true);
             
          }
      ).catch(err=>{
        $('div.option_wrappers').show();  
        $(".option_Title").html(`选择赠品<i class="fr iconfont icon-close" tag="optionhide"></i>`)
        $(".optionsNone_text").html(`暂无赠品`)   
      });
        
      })
    }
}